module.exports = __webpack_public_path__ + "img/Bear14.87fbf5b8.jpg";